import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {GlobalService} from '../global.service';
import {ApiService} from '../api.service';
import { baseUrls} from '../appConstant';
import { ɵDomEventsPlugin } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DiscountService } from '../discount.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public cartdata: any;
  public logstatus = false;
  public totalamount = 0;
  mode: string;
  imagelink = baseUrls['images'];
  traveladdons = 0.00;
  addonchecklocal = false;
  addoncartid = [];
  subtotal = 0;
  public showAlert = false;
  public responseMessage = '';

  constructor(
    private globalService: GlobalService,
    public httpService: ApiService,
    public cdr: ChangeDetectorRef,
    private router: Router,
    private discountService: DiscountService) {
    this.logstatus = this.globalService.isLoggedIn;
    // this.showAlert = true;

  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }
  shopProductIncludeInCartData = false;
  ngOnInit(): void {
    this.addonchecklocal = this.globalService.addonscheck;
    if (localStorage.getItem('userToken') !== null && this.globalService.isLoggedIn) {
      const headerDict = {
        token: localStorage.getItem('userToken')
      };
      let url = 'cartservice';
      this.mode = 'indeterminate';
      this.httpService.postFormDatabill(url, {}, headerDict).subscribe(response => {
        // console.log('HomeComponent1',response);
        this.mode = 'determinate';
        this.cartdata = response.data;
        this.globalService.cartquantity = this.cartdata?.length ? this.cartdata?.length : 0;
        localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
        this.cartdata?.forEach(el => {
          this.getpayprice(el);
        });
        this.getSubtotal();
        this.getTotal();
        // this.calculateShippingForInsideUsa();
        this.getCountryListData();
        if(localStorage.getItem("countryNameSelectedForShipping")){
          this.CountrySelected = localStorage.getItem("countryNameSelectedForShipping")?.toString();
          this.countrySelectedChange({target:{value: localStorage.getItem("countryNameSelectedForShipping")?.toString()} } );
        }
      });
    } 
    else {
      if (Number(localStorage.getItem('cartquantity')) > -1 && this.globalService.cartquantity > 0) {
        let cartdata = JSON.parse(localStorage.getItem('cartdata'));
        if (cartdata?.length > 0) {
          this.cartdata = cartdata;
          console.log('ngOnInit1',this.cartdata);
          this.cartdata.forEach(el => {
            if(el?.type == "shop"){
              this.shopProductIncludeInCartData = true;
              this.subtotal = this.subtotal + (Number(el.payPrice) * Number(el.quantity));
              el.payPrice = (Number(el.payPrice) * Number(el.quantity));
            }
            if(this.cartdata.length !== this.addoncartid) {
              this.cartdata.forEach(el => {
                // console.log('ngOnInit1_1', this.addoncartid.includes(el.programId), el.programId, this.subtotal);
                
                if ( !(this.addoncartid.includes(el.programId)) ) {
                  // console.log('ngOnInit1_2', el, el?.type == "shop",  (Number(el.payPrice) * Number(el.quantity)));
                  this.addoncartid.push(el.programId);
                  if(el?.type == "shop"){
                    // this.subtotal = this.subtotal + (Number(el.payPrice) * Number(el.quantity));
                    // el.payPrice = (Number(el.payPrice) * Number(el.quantity));
                  }
                  else{
                    this.subtotal = this.subtotal + (Number(el.payPrice) - Number(el.totalAddonsValue));

                  }
                  this.traveladdons = this.traveladdons + Number(el.totalAddonsValue);
                }
                // console.log('ngOnInit2',this.subtotal, ((Number(el.payPrice)) - Number(el.totalAddonsValue)));
              });
              if (this.traveladdons > 0) {
                this.globalService.addonscheck = true;
              }
            }
            
            // console.log('ngOnInit_loop_1', el);
            this.totalamount = this.totalamount + parseFloat(el.payPrice);
          });
          // for shipping cost by default INSIDE USA 
          // this.calculateShippingForInsideUsa();
          this.getCountryListData();
          if(localStorage.getItem("countryNameSelectedForShipping")){
            this.CountrySelected = localStorage.getItem("countryNameSelectedForShipping")?.toString();
            this.countrySelectedChange({target:{value: localStorage.getItem("countryNameSelectedForShipping")?.toString()} } );
          }
        }
      }
    }

  }


  getpayprice(cartdat){
    // console.log('getpayprice', cartdat);
    let requiredDeposit = 0;
    let finalDeposit: any;
    if(cartdat?.itineraryData?.isDeposit === 1 && cartdat?.pay !== 'fullamount'){
      if(cartdat?.itineraryData?.depositOption === 'flatPrice') {
        requiredDeposit = cartdat.itineraryData.depositValue;
        if (cartdat.itineraryData?.addonsData && cartdat?.itineraryData?.addonsData.length > 0) {
          // finalDeposit = (requiredDeposit + cartdat.itineraryData.totalAddonsValue); //comment for removing addons by kc
          finalDeposit = (requiredDeposit);
        }else{
          finalDeposit=requiredDeposit*cartdat?.itineraryData?.people;//change for resort price;
        }
      } else {
        // finalDeposit = (((cartdat.itineraryData.priceAfterDiscount + cartdat.itineraryData.totalAddonsValue) * cartdat.itineraryData.depositValue) / 100).toFixed(2);//comment for removing addons by kc
        finalDeposit = (((cartdat?.itineraryData?.priceAfterDiscount) * cartdat?.itineraryData?.depositValue) / 100).toFixed(2);
      }
    } else {
      if(cartdat?.type == "shop"){
          this.shopProductIncludeInCartData = true;
          finalDeposit = (Number(cartdat?.itineraryData?.priceAfterDiscount) * cartdat?.itineraryData?.quantity);
      }
      else{
        // finalDeposit = (Number(cartdat.itineraryData.priceAfterDiscount) + Number(cartdat.itineraryData.totalAddonsValue));//comment for removing addons by kc
      finalDeposit = (Number(cartdat?.itineraryData?.priceAfterDiscount) );
      }
      // console.log('getpayprice2', finalDeposit);
    }

    this.cartdata.forEach(el => {
      if (cartdat._id && cartdat._id === el._id){
        // console.log('getpayprice3',el, cartdat._id === el._id, cartdat._id, el._id, finalDeposit);
        el.itineraryData.totalPayPrice = finalDeposit;
        el.itineraryData.fullamount = (cartdat?.itineraryData?.priceAfterDiscount + cartdat?.itineraryData?.totalAddonsValue);
      }
    });
    // return finalDeposit;
  }

  getSubtotal() {

    if(this.cartdata?.length !== this.addoncartid) {
      this.cartdata?.forEach(el => {
        if ( el.type == "shop") {
          this.subtotal = this.subtotal + (Number(el.itineraryData.totalPayPrice));
          return;
        }
        if (!(this.addoncartid.includes(el._id))) {
          this.addoncartid.push(el._id);
          // console.log(this.addoncartid.includes(el._id));
          // this.subtotal = this.subtotal + (Number(el.itineraryData.totalPayPrice) - el.itineraryData.totalAddonsValue); // comment for addons by kc
          this.subtotal = this.subtotal + (Number(el?.itineraryData?.totalPayPrice));
          // this.traveladdons = this.traveladdons + el.itineraryData.totalAddonsValue; // comment for addons by kc
          this.traveladdons = this.traveladdons + el?.itineraryData?.totalAddonsValue * el?.itineraryData?.people;
        }
        // console.log('getSubtotal', this.subtotal, ((Number(el.itineraryData.totalPayPrice)) - el.itineraryData.totalAddonsValue));
      });
      // console.log('getSubtotal2', this.subtotal);
      if (this.traveladdons > 0) {
        this.globalService.addonscheck = true;
      }
    }
  }

  getTotal(){
    this.cartdata?.forEach(el => {
      // this.totalamount = this.totalamount + Number(el.itineraryData.totalPayPrice);// code comment for fixing issue in total Value by kc
      if(el?.itineraryData?.totalPayPrice){
        this.totalamount = this.totalamount + Number(el?.itineraryData?.totalPayPrice) + el?.itineraryData?.totalAddonsValue * el.itineraryData.people;
      }
    });
  }

  deletecartitemlive(id: any){
    // console.log('deletecartitemlive',id);
    let url = 'cartservice/' + id;
    this.mode = 'indeterminate';
    this.httpService.postDeletebill(url).subscribe(response => {
      this.globalService.cartquantity = this.globalService.cartquantity - 1;
      localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
      // console.log('deletecartitemlive_2',response);
      this.mode = 'determinate';
      location.reload(true);
    });
  }

  deletecartitemlocal(id: any){
    let index = 0;
    this.cartdata.forEach(el => {
      if (el.programId === id){
         this.cartdata.splice(index, 1);
         localStorage.setItem('cartdata', JSON.stringify(this.cartdata));
         this.globalService.cartquantity = this.globalService.cartquantity - 1;
         localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
      }
      index = index + 1;

    });

    // console.log('deletecartitemlocal',this.cartdata);
    if (Number(localStorage.getItem('cartquantity')) > -1 && this.globalService.cartquantity > 0) {
      // let cartdatas = JSON.parse(localStorage.getItem('cartdata'));
      if (this.cartdata.length > 0) {
        this.subtotal = 0;
        this.traveladdons = 0;
        this.totalamount = 0.00;
        this.addoncartid = [];
        // this.cartdata = cartdatas;
        // console.log(this.cartdata);
        this.cartdata.forEach(el => {
          if(this.cartdata.length !== this.addoncartid) {
            this.cartdata.forEach(el => {
              if (!(this.addoncartid.includes(el.programId))) {
                this.addoncartid.push(el.programId);
                // console.log(this.addoncartid.includes(el.programId));
                this.subtotal = this.subtotal + (Number(el.payPrice) - Number(el.totalAddonsValue));
                this.traveladdons = this.traveladdons + Number(el.totalAddonsValue);
              }
              // console.log(this.subtotal, ((Number(el.payPrice)) - Number(el.totalAddonsValue)));
            });
            if (this.traveladdons > 0) {
              this.globalService.addonscheck = true;
            }
          }
          this.totalamount = this.totalamount + parseFloat(el.payPrice);
        });
      }
    }
    if(this.cartdata?.length == 0){
      this.shippingCharge = 0
    }

    this.shopProductIncludeInCartData = false; // by default on deleting any element we make it false 
    this.cartdata.forEach(el => {
      if(el?.type == "shop"){
        this.shopProductIncludeInCartData = true;
        return;
      }
    })
  }

  urlvideo(imagestring){
    if((typeof imagestring) == 'string'){
    return imagestring.includes('https');
    }else{
      return false;
    }
  }

  shippingInsideUsaFlag = true;
  shippingInsideUsa(info){
    console.log('shippingInsideUsa', info);
    if(info == 'YES'){
      this.shippingInsideUsaFlag = true;
      this.calculateShippingForInsideUsa();
    }
    if(info == 'NO'){
      this.shippingInsideUsaFlag = false;
      this.calculateShippingForOutsideUsa();
    }
  }

  shippingCharge = 0;
  calculateShippingForInsideUsa(){
    this.shippingCharge = 0;
    if(this.globalService.isLoggedIn){
      this.cartdata.forEach((obj: any) => {
        if(obj?.type == "shop"){
          console.log('calculateShippingForInsideUsa_1', obj, obj?.attr?.shippingInUSA >= 0 );
          if( obj?.attr?.shippingInUSA !== ""  && obj?.attr?.shippingInUSA >= 0 ){
            console.log('calculateShippingForInsideUsa_2',  obj?.attr?.shippingInUSA);
            this.shippingCharge += Number(obj?.attr?.shippingInUSA);
            this.checkoutButtonFlag = true;
          }
          else{
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
    })
    }
    else{
      this.cartdata.forEach((obj: any) => {
          if(obj?.type == "shop"){
            if(obj?.shippingInUSA !== ""  && obj?.shippingInUSA >= 0){
              this.shippingCharge += Number(obj?.shippingInUSA);
              this.checkoutButtonFlag = true;
            }
            else{
              this.checkoutButtonFlag = false;//Due to shippping Not Available Inside USA
              return;
            }
          }
      })
    }
  }

  checkoutButtonFlag = true;
  calculateShippingForOutsideUsa(){
    this.shippingCharge = 0;
    this.shippingInsideUsaFlag = false;
    if(this.globalService.isLoggedIn){
      // console.log('calculateShippingForOutsideUsa1', this.cartdata);
      this.cartdata?.forEach((obj: any) => {
        if(obj?.type == "shop"){
          // console.log('calculateShippingForOutsideUsa1_2', obj?.attr?.shippingOutUSA);
          if(obj?.attr?.shippingOutUSA){
            this.shippingCharge += Number(obj?.attr?.shippingOutUSA);
            this.checkoutButtonFlag = true;
          }
          else{
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
    })
    }
    else{
      console.log('calculateShippingForOutsideUsa2', this.cartdata);
      this.cartdata.forEach((obj: any) => {
        if(obj?.type == "shop"){
          console.log('calculateShippingForOutsideUsa2_2', this.cartdata);
          if(obj?.shippingOutUSA){
            this.shippingCharge += Number(obj?.shippingOutUSA);
          }
          else{
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
    })
    }
    
  }

  countryList = [];
  getCountryListData(){
    let url = 'global/country';
            this.httpService.getData(url).subscribe((res)=>{
              if(res && res['countryRecord']){
                this.countryList = res['countryRecord'];
              }
            });
  }

  CountrySelected;
  countrySelectedChange(eventPassed){
    // console.log('countrySelectedChange',  eventPassed?.target?.value );
    if(eventPassed?.target?.value  === "United States"){
      // console.log('countrySelectedChange_2',  eventPassed?.target?.value );
      this.shippingInsideUsaFlag = true;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForInsideUsa();
    }
    else{
      this.shippingInsideUsaFlag = false;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForOutsideUsa();
    }
  }
  
  clickOnNameRoute(eventPassed){
    console.log('clickOnNameRoute', eventPassed);
    if(eventPassed?.itineraryData?.slug){
      if(eventPassed?.type == "shop"){
        window.open(
          baseUrls?.hostedUrl +'shopwell/'+'product/'+eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if(eventPassed?.type == "digital-classes"){
        window.open(
          baseUrls?.hostedUrl +'livewell/'+'class/'+eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if(eventPassed?.type == "digital-programs"){
        window.open(
          baseUrls?.hostedUrl +'livewell/'+'program/'+eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if(eventPassed?.type == "onetooneclass"){
        window.open(
          baseUrls?.hostedUrl +'livewell/onetoone',
          '_blank'
        );
      }
      
      if(eventPassed?.type == "travel" && eventPassed?.country?.slug && eventPassed?.region?.slug){
        window.open(
          baseUrls?.hostedUrl +'travel/'+'destinations/'+eventPassed?.region?.slug + "/" +eventPassed?.country?.slug + "/"+eventPassed?.itineraryData?.categorySlug + '/' + eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      
    }
  }

  routeToCheckout(){
    console.log('routeToCheckout_2', this.cartdata?.length, this.checkoutButtonFlag);
    if((this.cartdata.length > 0 && this.checkoutButtonFlag)){
      this.router.navigate(["checkout"]);
    }
    if( (this.cartdata.length > 0) && (!this.checkoutButtonFlag) ){
      // this.router.
    }
  }
  hoverOnContinueCheckout= false;
}
